// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SystemSetting_wrapper__2-l7z"};